function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeClassHiddenBody(){
  const classNames = ['overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop'];

  classNames.map(function(className){
    if(document.body.classList.contains(className)){
      document.body.classList.remove(className);
      document.querySelector('.menu-drawer-container').classList.remove('menu-opening');
      document.getElementById('headerIconMenu').setAttribute('aria-expanded', 'false');
    }
  });
}

document.querySelectorAll('.menu-drawer__menu li').forEach(function(element){
  element.addEventListener('click', removeClassHiddenBody);
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    const collapsibleContent = summary.closest('.collapsible-content__grid');
    if (collapsibleContent) {
      collapsibleContent.querySelectorAll('[id^="Details-"] summary').forEach((_summary) => {
        if (_summary.id != summary.id) {
          _summary.closest('[id^="Details-"]').removeAttribute('open');
          _summary.setAttribute('aria-expanded', false);
        }
      });
    }
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  // removeHiddenBody(){
  //   document.querySelectorAll('.menu-drawer__menu li').addEventListener('click', ()=>{
  //     document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  //   });
  // } 

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class mediaGallery extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.arrowEvents();
  }

  init() {
    const _this = this;
    this.productMediaList = this.querySelector('.product__media-list');
    if (this.productMediaList) {
      this.productThumbnailList = this.querySelector('.thumbnail-slider');
      let sliderOptions = this.dataset.sliderOptions;
      let thumbOptions = this.dataset.thumbOptions;
  
      sliderOptions = JSON.parse(sliderOptions);
      this.slider = new KeenSlider(this.productMediaList, sliderOptions, [
        slider => {
          slider.on('created', () => {
            this.productMediaList.classList.add('keen-slider-enabled');
          }),
          slider.on('slideChanged', (evt) => {
            let index = _this.slider.track.details.rel;
            this.thumbnailSlider.moveToIdx(index);
          })
        },
      ]);
  
      thumbOptions = JSON.parse(thumbOptions);
      this.thumbnailSlider = new KeenSlider(this.productThumbnailList, thumbOptions, [
        slider => {
          function removeActive() {
			slider.slides.forEach(slide => {
				slide.classList.remove("active")
			})
          }
          function addActive(idx) {
			slider.slides[idx].classList.add("active")
          }

          function addClickEvents() {
			slider.slides.forEach((slide, idx) => {
              slide.addEventListener("click", () => {
                _this.slider.moveToIdx(idx)
              });
			});
          }
          slider.on("created", () => {
            this.productThumbnailList.classList.add('keen-slider-enabled');
			addActive(slider.track.details.rel), addClickEvents(), this.slider.on("animationStarted", main2 => {
              removeActive();
              const next = main2.animator.targetIdx || 0;
              addActive(main2.track.absToRel(next)), slider.moveToIdx(next)
			});
  		  });
        },
      ]);
    }
  }

  arrowEvents() {
    const _this = this;
    const arrowPrev = this.querySelector('.keen-slider-arrow-prev');
    const arrowNext = this.querySelector('.keen-slider-arrow-next');
    if (arrowPrev ){
      arrowPrev.addEventListener('click', function(evt){
        _this.slider.prev();
      });
    }
    if (arrowNext) {
      arrowNext.addEventListener('click', function(evt){
        _this.slider.next();
      });
    }
  }
}

customElements.define('media-gallery', mediaGallery);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class FeaturedCustomProductForm extends HTMLElement {
  constructor() {
    console.log('featured-product-form');
    
    super();
    const _this = this;
    
    this.$section = this.closest('.section-featured-products');
    
    if (!this.$section) {
      this.$section = this.closest('product-info');
    }
    
    if (!this.$section) {
      return;
    }
    
    this.init();
    
    this.$quantityBox.forEach(function(box){
      _this.quantityControlEventListener(box);
    });
    
    this.updatePrice();
    this.addToCartEventListener();
  }

  init() {
    const _this = this;
    
    this.$subscribe = parseInt(this.dataset.subscribe);
    this.$quantityBox = this.closest('.custom-form-box-block').querySelectorAll('.product-quantity-box');
    
    const productJsonData = this.$section.querySelector('.product-data-json');
    this.$productJsonData = {};
    
    if (productJsonData) {
      this.$productJsonData  = productJsonData.innerHTML.trim();
      this.$productJsonData  = JSON.parse(this.$productJsonData  || '{}');
    }
    
    const productOptionJson = this.$section.querySelector('.product-option-json');
    
    this.$productOptionnData = {};
    if (productOptionJson) {
      this.$productOptionnData  = productOptionJson.innerHTML.trim();
      this.$productOptionnData  = JSON.parse(this.$productOptionnData  || '{}');
    }

    this.$product_handle = this.$productOptionnData['handle'];
    this.$full_price_onetime = this.$productOptionnData['full_price_onetime'];
    this.$full_price_subscribe = this.$productOptionnData['full_price_subscribe'];
    this.$each_price_onetime = parseInt(this.$productOptionnData['each_price_onetime']);
    this.$each_price_subscribe = parseInt(this.$productOptionnData['each_price_subscribe']);
    this.$percentage = this.$productOptionnData['percentage'];
    
    this.$variant_1_option = this.$productOptionnData['variant_1_option'] || null;
    this.$variant_2_option = this.$productOptionnData['variant_2_option'] || null;
    this.$first_bag_product = this.$productOptionnData['first_bag_product'];

    this.$subsribePrice = parseInt(this.$full_price_subscribe*100);
    this.$onetimePrice = parseInt(this.$full_price_onetime*100);

    this.$variant_1 = [];
    this.$variant_2 = [];
    console.log("op1", this.$variant_1_option );
    console.log("op2", this.$variant_1_option );
    this.$productJsonData.variants.forEach(function(variant){
      if (_this.$variant_1_option && _this.$variant_2_option) {
      _this.getVariantOption(variant);
      }else {
        _this.$variant_1 = _this.$productJsonData.variants || [];
        _this.$variant_2 = _this.$productJsonData.variants || [];
      }
      //console.log("varient1",variant);
    });

    //console.log(_this.$variant_1);
    //console.log(_this.$variant_2);

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = null;

    this.addEventListener('click', function(evt){
      _this.$section.querySelectorAll('.featured-product-form').forEach(function(form){
        form.classList.remove('active');
      });
      evt.currentTarget.classList.add('active');
    });
  }

  getVariantOption(variant) {
    let _this = this;
    /*
    if (variant.option2 != null) {
      if (_this.$subscribe == 1) {
        if (variant.option2 != 'SNS') {
          return;
        } 
      } else {
        if (variant.option2 != 'OTP') {
          return;
        }
      }
    }*/
    if (variant.option1.indexOf(_this.$variant_1_option) != -1) {
      if (variant != null) {
        /*
        if (variant.option1 == `${_this.$variant_1_option} (First Bag)`) {
          if (_this.$first_bag_product) {
            _this.$variant_1[0] = variant;
          }
        } else if (variant.option1 == _this.$variant_1_option) {
          if (_this.$first_bag_product) {
            _this.$variant_1[1] = variant;
          } else {
            _this.$variant_1[0] = variant;
          }
        }*/
        if (variant.option1 == _this.$variant_1_option) {
          _this.$variant_1[0] = variant;
        }
      }
    }
    
    if (variant.option1.indexOf(_this.$variant_2_option) != -1) {
      if (variant != null) {
        /*
        if (variant.option1 == `${_this.$variant_2_option} (First Bag)`) {
          if (_this.$first_bag_product) {
            _this.$variant_2[0] = variant;
          }
        } else if (variant.option1 == _this.$variant_2_option) {
          if (_this.$first_bag_product) {
            _this.$variant_2[1] = variant;
          } else {
            _this.$variant_2[0] = variant;
          }
        }*/
        if (variant.option1 == _this.$variant_2_option) {
          _this.$variant_2[0] = variant;
        }
      }
    }
  }

  addToCartEventListener() {
    const _this = this;
    const addToCartButton = this.querySelector('.product-form__submit');
    const go_check_out = this.querySelector('.product-form__submit-checkout');
    const freeProduct = this.querySelector('.featured-product-free');
    let packProductHandle = '';
    
    if (addToCartButton) {
      addToCartButton.addEventListener('click', function(evt){
        console.log("adding to cart!");
        const submitButton = evt.currentTarget;
        let items = [], hasDiscounted = 0;
        let hasHandle = 0;
          
        fetch(`${routes.cart_url}.json`)
          .then((response) => response.json())
          .then((response) => {
            processAddToCart(response);
          })
          .catch((e) => {
            console.error(e);
          });


        async function processAddToCart(data) {
          let product;
          await fetch(`/products/${_this.$product_handle}.js`)
            .then((response) => response.json())
            .then((response) => {
              product = response
            })
            .catch((e) => {
              console.error(e);
            });

          const appId = "5859381";

          const selling_plan_group_ids = []
          product?.selling_plan_groups.map((group) => {
            if (group.app_id === appId) {
              selling_plan_group_ids.push(group.id)
            }
          })

          //console.log("Do we have selling_plan_groups??", product)
          let formData, hasFreeProductInCart = 0;
          data.items.map((item) => {
            if (item.handle == 'free-kids-shirt' && item.properties._pack == _this.$productJsonData.handle) {
              hasFreeProductInCart = 1;
            }
          });
          
          if (freeProduct && !hasFreeProductInCart) {
            freeProduct.classList.remove('error');
            const id = freeProduct.value;
            if (id) {
              items.push({ 'id': id, 'quantity': 1, 'properties': {'_pack': _this.$productJsonData.handle} });
            }
          }

          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          
          _this.$quantityBox.forEach(function(box){
            const variants = _this.getBoxVariants(box);
            for (const variant of variants) {
              //console.log("Hello???????", variant)
              variant.selling_plan_allocations = variant.selling_plan_allocations.filter((allocation) => selling_plan_group_ids.includes(allocation.selling_plan_group_id))
            }
            const quantityInput = box.querySelector('.product-quantity-input');
            let quantity = parseInt(quantityInput.innerText);

            if (quantity > 0) {
              /*
              if (_this.$first_bag_product) {
                data.items.map((item) => {
                  if (item.title.indexOf('First Bag') != -1 && item.handle == _this.$productJsonData.handle) {
                    if (_this.$subscribe) {
                      if ('selling_plan_allocation' in item) {
                        hasDiscounted = 1;  
                      }
                    } else {
                      if (!('selling_plan_allocation' in item)) {
                        hasDiscounted = 1;
                      }
                    }
                  }
                });
                if (_this.$subscribe) {
                  if (!hasDiscounted) {
                    items.push({ 'id': variants[0].id, 'quantity': 1, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
                    hasDiscounted = 1;
                    quantity --;
                  }
                  if (hasDiscounted && quantity) {
                    items.push({ 'id': variants[1].id, 'quantity': quantity, 'selling_plan': variants[1].selling_plan_allocations[0].selling_plan_id });
                  }
                } else {
                  if (!hasDiscounted) {
                    items.push({ 'id': variants[0].id, 'quantity': 1 });
                    hasDiscounted = 1;
                    quantity --;
                  }
                  if (hasDiscounted && quantity) {
                    items.push({ 'id': variants[1].id, 'quantity': quantity });
                  }
                }
              } else {
                if (_this.$subscribe) {
                  items.push({ 'id': variants[0].id, 'quantity': quantity, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
                } else {
                  items.push({ 'id': variants[0].id, 'quantity': quantity });
                }
              }
              */
              if (_this.$subscribe) {
                items.push({ 'id': variants[0].id, 'quantity': quantity, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
              } else {
                items.push({ 'id': variants[0].id, 'quantity': quantity });
              }
            }
          });

          if (_this.cart) {
            formData = {
              'items': items,
              'sections': _this.cart.getSectionsToRender().map((section) => section.id),
              'sections_url': window.location.pathname
            };
          } else {
            formData = {
              'items': items
            };
          }
          
          _this.addToCart(submitButton, formData);
          //_this.clearToCart(submitButton, formData);
          return;
        }
      });
    }
    if (go_check_out) {
      console.log("go_check_out!");

       go_check_out.addEventListener('click', function(evt){
        document.querySelectorAll('.drawer').forEach(drawer => {
        drawer.style.display = 'none';
        drawer.style.visibility = 'hidden'; 
    });
  
        const submitButton = evt.currentTarget;
        let items = [], hasDiscounted = 0;
        let hasHandle = 0;
          
        fetch(`${routes.cart_url}.json`)
          .then((response) => response.json())
          .then((response) => {
            processAddToCart(response);
          })
          .catch((e) => {
            console.error(e);
          });


        async function processAddToCart(data) {
          let product;
          await fetch(`/products/${_this.$product_handle}.js`)
            .then((response) => response.json())
            .then((response) => {
              product = response
            })
            .catch((e) => {
              console.error(e);
            });

          const appId = "5859381";

          const selling_plan_group_ids = []
          product?.selling_plan_groups.map((group) => {
            if (group.app_id === appId) {
              selling_plan_group_ids.push(group.id)
            }
          })

          //console.log("Do we have selling_plan_groups??", product)
          let formData, hasFreeProductInCart = 0;
          data.items.map((item) => {
            if (item.handle == 'free-kids-shirt' && item.properties._pack == _this.$productJsonData.handle) {
              hasFreeProductInCart = 1;
            }
          });
          
          if (freeProduct && !hasFreeProductInCart) {
            freeProduct.classList.remove('error');
            const id = freeProduct.value;
            if (id) {
              items.push({ 'id': id, 'quantity': 1, 'properties': {'_pack': _this.$productJsonData.handle} });
            }
          }

          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          
          _this.$quantityBox.forEach(function(box){
            const variants = _this.getBoxVariants(box);
            for (const variant of variants) {
              //console.log("Hello???????", variant)
              variant.selling_plan_allocations = variant.selling_plan_allocations.filter((allocation) => selling_plan_group_ids.includes(allocation.selling_plan_group_id))
            }
            const quantityInput = box.querySelector('.product-quantity-input');
            let quantity = parseInt(quantityInput.innerText);

            if (quantity > 0) {
              /*
              if (_this.$first_bag_product) {
                data.items.map((item) => {
                  if (item.title.indexOf('First Bag') != -1 && item.handle == _this.$productJsonData.handle) {
                    if (_this.$subscribe) {
                      if ('selling_plan_allocation' in item) {
                        hasDiscounted = 1;  
                      }
                    } else {
                      if (!('selling_plan_allocation' in item)) {
                        hasDiscounted = 1;
                      }
                    }
                  }
                });
                if (_this.$subscribe) {
                  if (!hasDiscounted) {
                    items.push({ 'id': variants[0].id, 'quantity': 1, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
                    hasDiscounted = 1;
                    quantity --;
                  }
                  if (hasDiscounted && quantity) {
                    items.push({ 'id': variants[1].id, 'quantity': quantity, 'selling_plan': variants[1].selling_plan_allocations[0].selling_plan_id });
                  }
                } else {
                  if (!hasDiscounted) {
                    items.push({ 'id': variants[0].id, 'quantity': 1 });
                    hasDiscounted = 1;
                    quantity --;
                  }
                  if (hasDiscounted && quantity) {
                    items.push({ 'id': variants[1].id, 'quantity': quantity });
                  }
                }
              } else {
                if (_this.$subscribe) {
                  items.push({ 'id': variants[0].id, 'quantity': quantity, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
                } else {
                  items.push({ 'id': variants[0].id, 'quantity': quantity });
                }
              }
              */
              if (_this.$subscribe) {
                items.push({ 'id': variants[0].id, 'quantity': quantity, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
              } else {
                items.push({ 'id': variants[0].id, 'quantity': quantity });
              }
            }
          });

          if (_this.cart) {
            formData = {
              'items': items,
              'sections': _this.cart.getSectionsToRender().map((section) => section.id),
              'sections_url': window.location.pathname
            };
          } else {
            formData = {
              'items': items
            };
          }
          
         // _this.addToCart(submitButton, formData);
           _this.clearToCartany(submitButton, formData);

       
          return;
        }
      });
 
    }
  }
  clearToCartany(submitButton, formData) {
    const _this = this;
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      _this.addToCart(submitButton, formData);
       window.location.href = '/checkout';
       document.querySelectorAll('.drawer').forEach(drawer => {
        drawer.style.display = 'block';});
      document.querySelectorAll('.cart-drawer').forEach(drawer => {
        drawer.style.display = 'block';
    });
      document.querySelectorAll('.drawer__cart-items-wrapper').forEach(drawer => {
        drawer.style.display = 'block';
    });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  clearToCart(submitButton, formData) {
    const _this = this;
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      _this.addToCart(submitButton, formData);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  addToCart(submitButton, formData) {
    console.log("🛒 formData.items", JSON.stringify(formData.items, null, 2));
    this.isAddingToCart=false;
    const _this = this;
    const isBundle = (this.$variant_1_option && this.$variant_2_option) ;

    console.log('isBundle',isBundle);

    const customFormBox = this.closest('custom-form-box');

    if (customFormBox) {
      submitButton = customFormBox.querySelector('.custom-form-box-form__submit');
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then((response) => {
      //window.location = '/checkout/';
      //return;
      //if (_this.$subscribe) {
      //  window.location = '/checkout/';//window.routes.cart_url;
      //} else {
      
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.items[0].id,
          errors: response.errors || response.description,
          message: response.message,
        });
        _this.handleErrorMessage(response.description);
        _this.error = true;
        return;
      } else if (!_this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
    
      if (!_this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.items[0].id,
          cartData: response
        });
      _this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              _this.cart.renderContents(response);
            });
          }, {
            once: true
          }
        );
        quickAddModal.hide(true);
      } else {
        _this.cart.renderContents(response);
      }
      
      //}
      
    })
    .catch((e) => {
      console.error(e);
    })
    .finally((response) => {
      
      submitButton.classList.remove('loading');
      submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      if (_this.cart && this.cart.classList.contains('is-empty')) _this.cart.classList.remove('is-empty');
      if (!_this.error) submitButton.removeAttribute('aria-disabled');
    });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  quantityControlEventListener(box) {
    const _this = this;
    const plusControl = box.querySelector('.product-quantity-control-plus');
    const minusControl = box.querySelector('.product-quantity-control-minus');
    const quantityInput = box.querySelector('.product-quantity-input');
    let quantity = parseInt(quantityInput.innerText);
    quantityInput.addEventListener('keydown', function(){
      quantityInput.innerText = parseInt(quantityInput.value);
    });
    plusControl.addEventListener('click', function(){
      quantity ++;
      quantityInput.innerText = quantity;
      _this.updatePrice();
    });
    minusControl.addEventListener('click', function(){
      if (quantity >= 1) {
        quantity --;
      }
      quantityInput.innerText = quantity;
      _this.updatePrice();
    });
  }

  getBoxVariants(box) {
    
    const option = parseInt(box.dataset.variantOption);
      if (this.$variant_1_option && this.$variant_2_option) {

    console.log("option:", option);
    if (option == 1) {
      return this.$variant_1;
    } else if (option == 2) {
      return this.$variant_2;
    } else {
      return {};
    }
  }else {
    return this.$variant_1;
  }
  }

  updatePrice() {
    const _this = this;
    let option, 
      quantityInput, 
      variant, 
      allQuantity = 0, 
      compare_at_price = 0, 
      regular_price = 0, 
      save_price = 0, 
      quantity = 0,
      percentOff = 0,
      hasDiscounted = 0;
    const moneyFormat = '${{amount}}';
    
    this.$quantityBox.forEach(function(box){
      quantityInput = box.querySelector('.product-quantity-input');
      quantity = parseInt(quantityInput.innerText);
      allQuantity += quantity;
    });
    
    this.$quantityBox.forEach(function(box){
      quantityInput = box.querySelector('.product-quantity-input');
      quantity = parseInt(quantityInput.innerText);
      const variants = _this.getBoxVariants(box);
      //console.log(quantity);
      if (quantity > 0) {
        /*
        if (_this.$first_bag_product) {
          if (_this.$subscribe) {//Subscription
            let selling_plan_allocations = variants[0].selling_plan_allocations[0];
            if (!hasDiscounted) {
              regular_price += selling_plan_allocations.price * 1;
              compare_at_price += _this.$subsribePrice;
              hasDiscounted = 1;
              quantity --;
            }
            
            if (hasDiscounted && quantity) {
              selling_plan_allocations = variants[0].selling_plan_allocations[0];
              compare_at_price += variants[0].compare_at_price * quantity;//selling_plan_allocations.price * quantity;
              selling_plan_allocations = variants[1].selling_plan_allocations[0];
              regular_price += selling_plan_allocations.price * quantity;
            }
          } else {//Onetime
            if (!hasDiscounted) {
              regular_price += variants[0].price * 1;
              compare_at_price += _this.$onetimePrice;
              hasDiscounted = 1;
              quantity --;
            }
            if (hasDiscounted && quantity) {
              compare_at_price += variants[0].compare_at_price * quantity;
              regular_price += variants[1].price * quantity;
            }
          }
        } else {
          if (_this.$subscribe) {//Subscription
            let selling_plan_allocations = variants[0].selling_plan_allocations[0];
            regular_price += selling_plan_allocations.price * quantity;
            compare_at_price += variants[0].price * quantity;
          } else {//Onetime
            regular_price += variants[0].price * quantity;
            compare_at_price = variants[0].price * quantity;
          }
        }
        */
        if (_this.$subscribe) {//Subscription
          let selling_plan_allocations = variants[0].selling_plan_allocations[0];
          regular_price += selling_plan_allocations.price * quantity;
          compare_at_price += variants[0].price * quantity;
        } else {//Onetime
          regular_price += variants[0].price * quantity;
          compare_at_price = variants[0].price * quantity;
        }
      }
    });

    if (_this.$subscribe) {//Subscription
      compare_at_price += this.$subsribePrice - this.$onetimePrice; 
    }
  
    if (compare_at_price > regular_price) {
      save_price = compare_at_price - regular_price;
    }

    if (this.$each_price_onetime != 0 && this.$each_price_subscribe != 0) {
      save_price = (this.$each_price_onetime - this.$each_price_subscribe)*100;
      compare_at_price = regular_price + save_price
    }
    
    if (this.querySelector('.empty-text')) {
      if (allQuantity == 0) {
        this.querySelector('.empty-text').classList.remove('hide');
      } else {
        this.querySelector('.empty-text').classList.add('hide');
      }
    }

    if (regular_price >= compare_at_price) {
      this.querySelector('.compare-price').classList.add('hide');
    } else {
      this.querySelector('.compare-price').classList.remove('hide');
    }

    if (this.querySelector('.save-price')) {
      if (save_price == 0) {
        this.querySelector('.save-price').classList.add('hide');
      } else {
        this.querySelector('.save-price').classList.remove('hide');
      }
    }

    if (regular_price == 0) {
      this.querySelector('.regular-price').classList.add('hide');
    } else {
      this.querySelector('.regular-price').classList.remove('hide');
    }

    /*
    if (save_price && this.querySelector('[data-percent-off]')) {
      percentOff = (this.$onetimePrice - this.$productJsonData.price)/this.$onetimePrice*100;
      percentOff = Math.round(percentOff);
      //console.log(this.$onetimePrice);
      if (this.$percentage != '') {
        percentOff = this.$percentage;
      }
      this.querySelector('[data-percent-off]').innerText = percentOff + '%';
    }*/
    
    this.querySelector('[data-regular-price]').innerText = moneyFormat.replace('{{amount}}', (regular_price/100).toFixed(2));
  
          const elements = document.querySelectorAll('[data-regular-price-any]');
    const elements1 = document.querySelectorAll('[data-regular-price-any-or]');
    elements.forEach(el => {
      const formattedPrice = moneyFormat.replace('{{amount}}', (regular_price / 100 * 0.8).toFixed(2));
      el.innerText = formattedPrice;
    });
    elements1.forEach(el => {
      const formattedPrice = moneyFormat.replace('{{amount}}', (regular_price / 100 ).toFixed(0));
      el.innerText = formattedPrice;
    });
    this.querySelector('[data-compare-price]').innerText = moneyFormat.replace('{{amount}}', (compare_at_price/100).toFixed(2));
    /*
    if (this.querySelector('[data-save-price]')) {
      //this.querySelector('[data-save-price]').innerText = moneyFormat.replace('{{amount}}', (save_price*allQuantity/100));
      let savePrice = 10;
      if (allQuantity > 1) {
        if (this.$product_handle == 'chill') {
          savePrice += (allQuantity - 1) * 14;
        } else {
          savePrice += (allQuantity - 1) * 20;
        }
      }
      this.querySelector('[data-save-price]').innerText = `$${savePrice}`;
    }*/
    if (this.querySelector('[data-save-price]')) {
      this.querySelector('[data-save-price]').innerText = moneyFormat.replace('{{amount}}', Math.round(save_price/100));
    }
  }
}

customElements.define('featured-product-form', FeaturedCustomProductForm);

class CustomFormBox extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.addToCartEventListener();
  }

  addToCartEventListener() {
    const _this = this;
    const addToCartButton = this.querySelector('.custom-form-box-form__submit');
    const addToCartButtoncheckout = this.querySelector('.custom-form-box-form__submit-checkout');
    const check_out_link = this.querySelector('.custom-form-box-check_out_link');
    /*if(addToCartButtoncheckout) {
 
            addToCartButtoncheckout.addEventListener('click', function(evt){
        let customForm;
        _this.querySelectorAll('.custom-form-box').forEach(function(formBox){
          if (formBox.classList.contains('active')) {
            customForm = formBox;
          }
        });
        addToCartButtoncheckout.setAttribute('aria-disabled', true);
        addToCartButtoncheckout.classList.add('loading');
         addToCartButtoncheckout.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        customForm.querySelector('.product-form__submit').click();
        
        return;
      });
    }*/
    if(check_out_link) {

      check_out_link.addEventListener('click', function(evt){
        let customForm;
        _this.querySelectorAll('.custom-form-box').forEach(function(formBox){
          if (formBox.classList.contains('Anytime-PDP')) {
            customForm = formBox;
          }
        });
        check_out_link.setAttribute('aria-disabled', true);
        check_out_link.classList.add('loading');
        
        customForm.querySelector('.product-form__submit').click();
        
        return;
      });
    }
    if (addToCartButton) {
      addToCartButton.addEventListener('click', function(evt){
        let customForm;
        _this.querySelectorAll('.custom-form-box').forEach(function(formBox){
          if (formBox.classList.contains('active')) {
            customForm = formBox;
          }
        });
        addToCartButton.setAttribute('aria-disabled', true);
        addToCartButton.classList.add('loading');
        addToCartButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        customForm.querySelector('.product-form__submit').click();
        return;
        
      });
    }
  }
}
customElements.define('custom-form-box', CustomFormBox);

class VideoColumnCard extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.playEventListener();
    console.log('video-column-card');
  }

  playEventListener() {
    const _this = this;
    const video = this.querySelector('video');
    const playButton = this.querySelector('.video-play-button');
    const pauseButton = this.querySelector('.video-pause-button');
    
    video.addEventListener("timeupdate", (event) => {
      if (video.paused) {
        _this.classList.remove('hide-play-button');
      }
    });
    
    if (playButton) {
      const video = this.querySelector('video');
      this.addEventListener('click', function(evt) {
        const allVideoCards = document.querySelectorAll('featured-video-column-card');
        allVideoCards.forEach((card) => {
          if (card != _this) {
            card.classList.remove('hide-play-button');
            const _video = card.querySelector('video');
            _video.pause();
            //_video.currentTime = 0;
          }
        });
        if (!_this.classList.contains('hide-play-button')) {
          video.play();
          _this.classList.add('hide-play-button');
        } else {
          video.pause();
          _this.classList.remove('hide-play-button');
        }
        
        /*
        if (document.body.classList.contains('opened-ugc-modal')) {
          const allVideoCards = document.querySelectorAll('featured-video-column-card');
          allVideoCards.forEach((card) => {
            card.classList.remove('hide-play-button');
            const _video = card.querySelector('video');
            _video.pause();
            _video.currentTime = 0;
          });
          video.play();
          _this.classList.add('hide-play-button');
        }

        if (!document.body.classList.contains('opened-ugc-modal')) {
          const videoList = this.closest('.featured-video-column-list');
          const id = videoList.dataset.ugcModalId;
          const ugcModal = document.querySelector(`#${id}`);
          document.body.classList.add('opened-ugc-modal');
          if (ugcModal) {
            ugcModal.classList.add('active');
          }
        }*/
      });
    }
    if (pauseButton) {
      pauseButton.addEventListener('click', function(evt){
        video.pause();
        _this.classList.remove('hide-play-button');
      });
    }
  }
}
customElements.define('featured-video-column-card', VideoColumnCard);

class FeaturedVideoColumnUGCModal extends HTMLElement {
  constructor() {
    super();
    this.createSlide();
    this.eventListener();
  }

  eventListener() {
    
    const _this = this;
    
    this.sliderVideoColumns = this.querySelectorAll('.featured-video-column-list-slider .featured-video-column-card')
    this.videoColumns = this.querySelectorAll('.featured-video-column-list .featured-video-column-card');
    
    this.closeButton = this.querySelector('.arrow-close');
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', function(evt){
        const ugcModal = this.closest('featured-video-column-ugc-modal');
        if (ugcModal) {
          ugcModal.querySelector('.featured-video-column-ugc-modal').classList.remove('active');
        }
        document.body.classList.remove('opened-ugc-modal');
        _this.stopVideos();
      });
    }

    this.videoColumns.forEach((card, index) => _this.columnEventListener(card, index));
    this.sliderVideoColumns.forEach((card, index) => _this.playEventListener(card, index));
  }

  stopVideos() {
    this.querySelectorAll('.featured-video-column-card').forEach((card, index) => {
      const video = card.querySelector('video');
      card.classList.remove('hide-play-button');
      video.pause();
      video.currentTime = 0;
    });
  }

  columnEventListener(card, index) {
    const _this = this;
    const video = card.querySelector('video');
    const playButton = card.querySelector('.video-play-button');
    const pauseButton = card.querySelector('.video-pause-button');
    
    playButton.addEventListener('click', function(evt){
      if (_this.slider != null) {
        _this.slider.moveToIdx(index);
        const ugcModal = this.closest('featured-video-column-ugc-modal');
        //const videoList = this.closest('.featured-video-column-list');
        //const id = videoList.dataset.ugcModalId;
        document.body.classList.add('opened-ugc-modal');
        if (ugcModal) {
          ugcModal.querySelector('.featured-video-column-ugc-modal').classList.add('active');
        }
      }
    });
  }

  playEventListener(card, index) {
    const _this = this;
    const video = card.querySelector('video');
    const playButton = card.querySelector('.video-play-button');
    const pauseButton = card.querySelector('.video-pause-button');
    
    video.addEventListener("timeupdate", (event) => {
      if (video.paused) {
        card.classList.remove('hide-play-button');
      }
    });
    
    if (playButton) {
      const video = card.querySelector('video');
      
      playButton.addEventListener('click', function(evt) {
        if (document.body.classList.contains('opened-ugc-modal')) {
          _this.stopVideos();
          video.play();
          card.classList.add('hide-play-button');
        }

        if (!document.body.classList.contains('opened-ugc-modal')) {
          document.body.classList.add('opened-ugc-modal');
        }
      });
    }
    if (pauseButton) {
      pauseButton.addEventListener('click', function(evt){
        video.pause();
        card.classList.remove('hide-play-button');
      });
    }
  }

  createSlide() {
    const _this = this;
    let sliderOptions = this.dataset.sliderOptions;
    this.slider = null;
    this.keenSlider = this.querySelector('.keen-slider-main');
    //this.keenSliderArrow = this.querySelectorAll('.keen-slider-arrow');
    this.keenSliderArrowLeft = this.querySelector('.arrow--left');
    this.keenSliderArrowRight = this.querySelector('.arrow--right');

    if (sliderOptions) {
      sliderOptions = JSON.parse(sliderOptions);
      this.slider = new KeenSlider(this.keenSlider, sliderOptions, [
        slider => {
          function removeActive() {
            slider.slides.forEach(slide => {
              slide.classList.remove("active")
            })
          }

          function addActive(idx) {
            slider.slides[idx].classList.add("active")
          }

          slider.on('created', () => {
              _this.keenSlider.classList.add('keen-slider-enabled');
              removeActive();
              addActive(slider.track.details.rel);
            }),
            slider.on('slideChanged', (evt) => {
              removeActive();
              addActive(slider.track.details.rel);
            })
        },
      ]);
    }

    const allCount = (_this.slider.slides.length);
    if (this.keenSliderArrowLeft) {
      this.keenSliderArrowLeft.addEventListener("click", () => {
        let index = _this.slider.track.details.rel;
        if (index == 0) {
          index = allCount - 1;
        } else {
          index--;
        }
        _this.stopVideos();
        _this.slider.moveToIdx(index);
      });
    }

    if (this.keenSliderArrowRight) {
      this.keenSliderArrowRight.addEventListener("click", () => {
        let index = _this.slider.track.details.rel;
        if (index == allCount - 1) {
          index = 0;
        } else {
          index++;
        }
        _this.stopVideos();
        _this.slider.moveToIdx(index);
      });
    }
    
  }
}
customElements.define('featured-video-column-ugc-modal', FeaturedVideoColumnUGCModal);

class FeaturedVideoWithTextMedia extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.playEventListener();
  }

  playEventListener() {
    const _this = this;
    const video = this.querySelector('video');
    const playButton = this.querySelector('.video-play-control');
    const pauseButton = this.querySelector('.video-pause-button');
    
    if (playButton) {
      playButton.addEventListener('click', function(evt){
        if(video.paused) {
          _this.classList.add('hide-play-button');
          return video.play();
        }
        video.pause();
        _this.classList.remove('hide-play-button');
      });
    }
    
    //if (pauseButton) {
    //  pauseButton.addEventListener('click', function(evt){
    //    video.pause();
    //    _this.classList.remove('hide-play-button');
    //  });
    //}
  }
}
customElements.define('featured-video-with-text__media', FeaturedVideoWithTextMedia);

class FeaturedBenefits extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.tabEventListener();
  }

  tabEventListener() {
    const _this = this;
    this.querySelectorAll('.featured-benefits_tab .featured-benefits_tab-item').forEach((tabItem) => {
      const tabIndex = tabItem.dataset.tabIndex;
      tabItem.addEventListener('click', function(evt){
        evt.preventDefault();
        _this.querySelectorAll('.featured-benefits_tab .featured-benefits_tab-item').forEach((item) =>{
          item.classList.remove('active');
        });
        _this.querySelectorAll('.featured-benefits_item').forEach((item) => {
          item.classList.remove('active');
        });
        tabItem.classList.add('active');
        _this.querySelector(`#featured-benefits_item-${tabIndex}`).classList.add('active');
      });
    });
  }
}
customElements.define('featured-benefits', FeaturedBenefits);

class KeenSliderHtml extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.init();
  }

  init() {
    const _this = this;
    let sliderOptions = this.dataset.sliderOptions;
    let thumbOptions = this.dataset.thumbOptions;

    this.keenSlider = this.querySelector('.keen-slider-main');
    this.keenSliderDots = this.querySelectorAll('.keen-slider-dot');
    this.keenSliderThumb = this.querySelector('.keen-slider-thumb');
    this.keenSliderArrow = this.querySelectorAll('.keen-slider-arrow');
    
    if (sliderOptions) {
      sliderOptions = JSON.parse(sliderOptions);
      this.slider = new KeenSlider(this.keenSlider, sliderOptions, [
        slider => {
          function removeActive() {
			slider.slides.forEach(slide => {
				slide.classList.remove("active")
			})
          }
          function addActive(idx) {
			slider.slides[idx].classList.add("active")
          }

          slider.on('created', () => {
            _this.keenSlider.classList.add('keen-slider-enabled');
            removeActive();
            addActive(slider.track.details.rel);
          }),
          slider.on('slideChanged', (evt) => {
            _this.updateClass('main');
            removeActive();
            addActive(slider.track.details.rel);
          })
        },
      ]);
  
      this.keenSliderDots.forEach((dot, index) => {
        dot.addEventListener('click', function(evt){
          _this.keenSliderDots.forEach((_dot) => {
            _dot.classList.remove('active');
          });
          dot.classList.add('active');
          _this.slider.moveToIdx(index);
        });
      });
    }

    if (this.keenSliderThumb && thumbOptions) {
      thumbOptions = JSON.parse(thumbOptions);
      const main = this.slider;
      this.thumbnail = new KeenSlider(this.keenSliderThumb, thumbOptions, [
        slider => {
          function removeActive() {
			slider.slides.forEach(slide => {
				slide.classList.remove("active")
			})
          }
          
          function addActive(idx) {
			slider.slides[idx].classList.add("active")
          }

          function addClickEvents() {
			slider.slides.forEach((slide, idx) => {
              slide.addEventListener("click", () => {
                main.moveToIdx(idx)
              });
			});
          }
          slider.on("created", () => {
			addActive(slider.track.details.rel), addClickEvents(), main.on("animationStarted", main2 => {
              removeActive();
              const next = main2.animator.targetIdx || 0;
              addActive(main2.track.absToRel(next)), slider.moveToIdx(next)
			});
  		  })
        },
      ]);
    }

    if (this.keenSliderArrow) {
      const allCount = (_this.slider.slides.length);
      this.keenSliderArrow.forEach(arrow => {
        arrow.addEventListener("click", () => {
          let index = _this.slider.track.details.rel;
          if (arrow.dataset.direction == 'left') {
            if (index == 0) {
              index = allCount - 1;
            } else {
              index --;
            }
          } else {
            if (index == allCount - 1) {
              index = 0;
            } else {
              index ++;
            }
          }
          _this.slider.moveToIdx(index);
        });
      });
    }
  }

  updateClass() {
    const slide = this.slider.track.details.rel;
    Array.from(this.keenSliderDots).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add('active')
        : dot.classList.remove('active')
    });
  }
}
customElements.define('keen-slider', KeenSliderHtml);

class FeaturedMulticolumnCard extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.modalOpen();
  }

  modalOpen() {
    const _this = this;
    const buttonLightBox = this.querySelector('a[data-button-lightbox]');
    
    if (buttonLightBox) {
      buttonLightBox.addEventListener('click', function(evt){
        evt.preventDefault();
        const link = buttonLightBox.getAttribute('data-button-lightbox');
        if (link) {
          _this.createModal(link);
        }
      });
    }
  }

  createModal(src) {
    const modalDiv = document.createElement('div');
    modalDiv.classList.add('modal');
    modalDiv.setAttribute('id', 'featured-multicolumn-modal');

    const modalContent = document.createElement('div');
    modalContent.classList.add('modal-content');

    const modalHeader = document.createElement('div');
    modalHeader.classList.add('modal-header');

    const modalClose = document.createElement('button');
    modalClose.innerHTML = '&times;';
    modalClose.classList.add('modal-close-btn');
    modalClose.addEventListener('click', function(evt){
      evt.preventDefault();
      document.body.classList.remove('opened-modal');
      document.querySelector('#featured-multicolumn-modal').remove();
    });

    modalHeader.appendChild(modalClose);
    
    const img = document.createElement('img');
    img.classList.add('modal-img');
    img.setAttribute('src', src);
    modalContent.appendChild(img);

    modalDiv.appendChild(modalHeader);
    modalDiv.appendChild(modalContent);
    
    document.body.classList.add('opened-modal');
    document.body.appendChild(modalDiv);
  }
}
customElements.define('featured-multicolumn-card', FeaturedMulticolumnCard);

class HeaderGroup extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.setHeaderHeight();
    window.addEventListener('resize', this.setHeaderHeight.bind(this));
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-group-height', `${this.offsetHeight}px`);
  }
}
customElements.define('header-group', HeaderGroup);

class ChooseFormBox extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.variantOptionEventListener();
    this.quantityControlEventListener();
    this.updatePrice();
    this.addToCartEventListener();
  }

  init() {
    const _this = this;
    const productJsonData = this.querySelector('.product-data-json');
    const productOptionJson = this.querySelector('.product-option-json');

    this.$quantity = 1;
    this.$currentOption = 1;
    this.$section = this.closest('.featured-product-v1');
    this.$subscribe = 1;//this.querySelector('.v1-purchase-option.active').dataset.purchaseOption;
    this.$variantOption = this.querySelectorAll('.v1-variant-option');
    this.$quantityOption = this.querySelectorAll('.v1-quantity-option');
    this.$iconWithTexts = this.$section.querySelectorAll('.product-section_icon-with-text');
    this.$percentElement = this.$section.querySelector('.percent-element');
    this.$productJsonData = {};
    
    if (productJsonData) {
      this.$productJsonData  = productJsonData.innerHTML.trim();
      this.$productJsonData  = JSON.parse(this.$productJsonData  || '{}');
    }
    
    this.$productOptionnData = {};
    if (productOptionJson) {
      this.$productOptionnData  = productOptionJson.innerHTML.trim();
      this.$productOptionnData  = JSON.parse(this.$productOptionnData  || '{}');
    }

    this.$product_handle = this.$productOptionnData['handle'];
    this.$full_price_onetime = this.$productOptionnData['full_price_onetime'];
    this.$full_price_subscribe = this.$productOptionnData['full_price_subscribe'];
    this.$each_price_onetime = parseInt(this.$productOptionnData['each_price_onetime']);
    this.$each_price_subscribe = parseInt(this.$productOptionnData['each_price_subscribe']);
    this.$percentage = this.$productOptionnData['percentage'];
    this.$variant_1_percent_off_texts = this.$productOptionnData['variant_1_percent_off_texts'];
    this.$variant_2_percent_off_texts = this.$productOptionnData['variant_2_percent_off_texts'];
    
    this.$variant_1_option = this.$productOptionnData['variant_1_option'];
    this.$variant_2_option = this.$productOptionnData['variant_2_option'];
    this.$first_bag_product = this.$productOptionnData['first_bag_product'];

    this.$subsribePrice = parseInt(this.$full_price_subscribe*100);
    this.$onetimePrice = parseInt(this.$full_price_onetime*100);

    this.$variant_1 = [];
    this.$variant_2 = [];

    this.$productJsonData.variants.forEach(function(variant){
      _this.getVariantOption(variant);
      
    });

    //console.log("varient1",_this.$variant_1);
    //console.log(_this.$variant_2);

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = null;
  }

  getVariantOption(variant) {
    let _this = this;
    /*
    if (variant.option2 != null) {
      if (_this.$subscribe == 1) {
        if (variant.option2 != 'SNS') {
          return;
        } 
      } else {
        if (variant.option2 != 'OTP') {
          return;
        }
      }
    }*/
    if (variant.option1.indexOf(_this.$variant_1_option) != -1) {
      if (variant != null) {
        /*
        if (variant.option1 == `${_this.$variant_1_option} (First Bag)`) {
          if (_this.$first_bag_product) {
            _this.$variant_1[0] = variant;
          }
        } else if (variant.option1 == _this.$variant_1_option) {
          if (_this.$first_bag_product) {
            _this.$variant_1[1] = variant;
          } else {
            _this.$variant_1[0] = variant;
          }
        }
        */

        if (variant.option1 == _this.$variant_1_option) {
          _this.$variant_1[0] = variant;
        }
      }
    }
    
    if (variant.option1.indexOf(_this.$variant_2_option) != -1) {
      if (variant != null) {
        /*
        if (variant.option1 == `${_this.$variant_2_option} (First Bag)`) {
          if (_this.$first_bag_product) {
            _this.$variant_2[0] = variant;
          }
        } else if (variant.option1 == _this.$variant_2_option) {
          if (_this.$first_bag_product) {
            _this.$variant_2[1] = variant;
          } else {
            _this.$variant_2[0] = variant;
          }
        }*/
        if (variant.option1 == _this.$variant_2_option) {
          _this.$variant_2[0] = variant;
        }
      }
    }
  }

  addToCartEventListener() {
    const _this = this;
    const addToCartButton = this.querySelector('.product-form__submit');

    const freeProduct = this.querySelector('.featured-product-free');
    let packProductHandle = '';
    console.log("addToCartEventListener!");
    if (addToCartButton) {
      console.log("addToCartButton!");
      addToCartButton.addEventListener('click', function(evt){
        const submitButton = evt.currentTarget;
        let items = [], hasDiscounted = 0;
        let hasHandle = 0;

        fetch(`${routes.cart_url}.json`)
          .then((response) => response.json())
          .then((response) => {
            processAddToCart(response);
          })
          .catch((e) => {
            console.error(e);
          });

        function processAddToCart(data) {
          let formData, hasFreeProductInCart = 0;
          data.items.map((item) => {
            if (item.handle == 'free-kids-shirt' && item.properties._pack == _this.$productJsonData.handle) {
              hasFreeProductInCart = 1;
            }
          });
          
          if (freeProduct && !hasFreeProductInCart) {
            freeProduct.classList.remove('error');
            const id = freeProduct.value;
            if (id) {
              items.push({ 'id': id, 'quantity': 1, 'properties': {'_pack': _this.$productJsonData.handle} });
            }
          }

          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          
          const variants = _this.getCurrentVariant();
          if (variants) {
            let quantity = _this.$quantity;

            if (quantity > 0) {
              /*
              if (_this.$first_bag_product) {
                data.items.map((item) => {
                  if (item.title.indexOf('First Bag') != -1 && item.handle == _this.$productJsonData.handle) {
                    if (_this.$subscribe) {
                      if ('selling_plan_allocation' in item) {
                        hasDiscounted = 1;  
                      }
                    } else {
                      if (!('selling_plan_allocation' in item)) {
                        hasDiscounted = 1;
                      }
                    }
                  }
                });
                if (_this.$subscribe) {
                  if (!hasDiscounted) {
                    items.push({ 'id': variants[0].id, 'quantity': 1, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
                    hasDiscounted = 1;
                    quantity --;
                  }
                  if (hasDiscounted && quantity) {
                    items.push({ 'id': variants[1].id, 'quantity': quantity, 'selling_plan': variants[1].selling_plan_allocations[0].selling_plan_id });
                  }
                } else {
                  if (!hasDiscounted) {
                    items.push({ 'id': variants[0].id, 'quantity': 1 });
                    hasDiscounted = 1;
                    quantity --;
                  }
                  if (hasDiscounted && quantity) {
                    items.push({ 'id': variants[1].id, 'quantity': quantity });
                  }
                }
              } else {
                if (_this.$subscribe) {
                  items.push({ 'id': variants[0].id, 'quantity': quantity, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
                } else {
                  items.push({ 'id': variants[0].id, 'quantity': quantity });
                }
              }*/
              if (_this.$subscribe) {
                items.push({ 'id': variants[0].id, 'quantity': quantity, 'selling_plan': variants[0].selling_plan_allocations[0].selling_plan_id });
              } else {
                items.push({ 'id': variants[0].id, 'quantity': quantity });
              }
            }
          }

          if (_this.cart) {
            formData = {
              'items': items,
              'sections': _this.cart.getSectionsToRender().map((section) => section.id),
              'sections_url': window.location.pathname
            };
          } else {
            formData = {
              'items': items
            };
          }
          
          _this.addToCart(submitButton, formData);
          return;
        }
      });
    }
    
  }

  clearToCart(submitButton, formData) {
    const _this = this;
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      _this.addToCart(submitButton, formData);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  addToCart(submitButton, formData) {
    const _this = this;
    const customFormBox = this.closest('custom-form-box');
    if (customFormBox) {
      submitButton = customFormBox.querySelector('.custom-form-box-form__submit');
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then((response) => {
      
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.items[0].id,
          errors: response.errors || response.description,
          message: response.message,
        });
        _this.handleErrorMessage(response.description);
        _this.error = true;
        return;
      } else if (!_this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
    
      if (!_this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.items[0].id,
          cartData: response
        });
      _this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              _this.cart.renderContents(response);
            });
          }, {
            once: true
          }
        );
        quickAddModal.hide(true);
      } else {
        _this.cart.renderContents(response);
      }

    })
    .catch((e) => {
      console.error(e);
    })
    .finally((response) => {
      
      submitButton.classList.remove('loading');
      submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      if (_this.cart && this.cart.classList.contains('is-empty')) _this.cart.classList.remove('is-empty');
      if (!_this.error) submitButton.removeAttribute('aria-disabled');
    });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
  
  quantityControlEventListener() {
    const _this = this;
    this.$quantityOption.forEach((qty) => {
      qty.addEventListener('click', function(){
        _this.$quantityOption.forEach((_qty) => {
          _qty.classList.remove('active');
        });
        qty.classList.add('active');
        _this.$quantity = parseInt(qty.dataset.quantity);
        _this.updatePrice();
      });
      if (qty.classList.contains('active')) {
        _this.$quantity = parseInt(qty.dataset.quantity);
      }
    });
  }

  variantOptionEventListener() {
    const _this = this;
    this.$variantOption.forEach((option) => {
      option.addEventListener('click', function(){
        _this.$variantOption.forEach((_option) => {
          _option.classList.remove('active');
        });
        option.classList.add('active');
        _this.$currentOption = parseInt(option.dataset.variantOption);
        _this.updatePrice();

        _this.$iconWithTexts.forEach((icon) => {
          if (!icon.classList.contains('show-always')) {
            icon.classList.add('hide');
          }
        });
        _this.$section.querySelectorAll(`.show-option${_this.$currentOption}`).forEach((icon) => {
          if (!icon.classList.contains('show-always')) {
            icon.classList.remove('hide');
          }
        });
      });
      if (option.classList.contains('active')) {
        _this.$currentOption = parseInt(option.dataset.variantOption);
      }
    });
  }

  getCurrentVariant() {
    if (this.$currentOption == 1) {
      return this.$variant_1;
    } else if (this.$currentOption == 2) {
      return this.$variant_2;
    } else {
      return {};
    }
  }

  updatePrice() {
    const _this = this;
    let option, 
      quantityInput, 
      variant, 
      allQuantity = 0, 
      compare_at_price = 0, 
      regular_price = 0, 
      save_price = 0, 
      quantity = _this.$quantity,
      percentOff = 0,
      hasDiscounted = 0;
      
    const moneyFormat = '${{amount}}';
    const variants = this.getCurrentVariant();
    
    if (variants) {
      if (quantity > 0) {
        /*
        if (_this.$first_bag_product) {
          if (_this.$subscribe) {//Subscription
            let selling_plan_allocations = variants[0].selling_plan_allocations[0];
            if (!hasDiscounted) {
              regular_price += selling_plan_allocations.price * 1;
              compare_at_price += _this.$subsribePrice;
              hasDiscounted = 1;
              quantity --;
            }
            
            if (hasDiscounted && quantity) {
              selling_plan_allocations = variants[0].selling_plan_allocations[0];
              compare_at_price += variants[0].compare_at_price * quantity;//selling_plan_allocations.price * quantity;
              selling_plan_allocations = variants[1].selling_plan_allocations[0];
              regular_price += selling_plan_allocations.price * quantity;
            }
          } else {//Onetime
            if (!hasDiscounted) {
              regular_price += variants[0].price * 1;
              compare_at_price += _this.$onetimePrice;
              hasDiscounted = 1;
              quantity --;
            }
            if (hasDiscounted && quantity) {
              compare_at_price += variants[0].compare_at_price * quantity;
              regular_price += variants[1].price * quantity;
            }
          }
        } else {
          if (_this.$subscribe) {//Subscription
            let selling_plan_allocations = variants[0].selling_plan_allocations[0];
            regular_price += selling_plan_allocations.price * quantity;
            compare_at_price += variants[0].price * quantity;
          } else {//Onetime
            regular_price += variants[0].price * quantity;
            compare_at_price = variants[0].price * quantity;
          }
        }
        */
        if (_this.$subscribe) {//Subscription
          let selling_plan_allocations = variants[0].selling_plan_allocations[0];
          regular_price += selling_plan_allocations.price * quantity;
          compare_at_price += variants[0].price * quantity;
        } else {//Onetime
          regular_price += variants[0].price * quantity;
          compare_at_price = variants[0].price * quantity;
        }
      }
    }

    if (compare_at_price > regular_price) {
      save_price = compare_at_price - regular_price;
    }

    if (this.$each_price_onetime != 0 && this.$each_price_subscribe != 0) {
      save_price = (this.$each_price_onetime - this.$each_price_subscribe)*100;
      compare_at_price = regular_price + save_price
    }
    
    if (this.querySelector('.empty-text')) {
      if (allQuantity == 0) {
        this.querySelector('.empty-text').classList.remove('hide');
      } else {
        this.querySelector('.empty-text').classList.add('hide');
      }
    }

    if (this.querySelector('.compare-price')) {
      if (regular_price >= compare_at_price) {
        this.querySelector('.compare-price').classList.add('hide');
      } else {
        this.querySelector('.compare-price').classList.remove('hide');
      }
    }
    
    if (this.querySelector('.save-price')) {
      if (save_price == 0) {
        this.querySelector('.save-price').classList.add('hide');
      } else {
        this.querySelector('.save-price').classList.remove('hide');
      }
    }

    if (regular_price == 0) {
      this.querySelector('.regular-price').classList.add('hide');
    } else {
      this.querySelector('.regular-price').classList.remove('hide');
    }

    if (save_price && this.querySelector('[data-percent-off]')) {
      percentOff = (this.$onetimePrice - this.$productJsonData.price)/this.$onetimePrice*100;
      percentOff = Math.round(percentOff);
      
      if (this.$percentage != '') {
        percentOff = this.$percentage;
      }
      this.querySelector('[data-percent-off]').innerText = percentOff + '%';
    }

    if (this.$currentOption == 1) {
      const percent_off_text = this.$variant_1_percent_off_texts[_this.$quantity - 1];
      if (percent_off_text != '') {
        this.$percentElement.innerText = percent_off_text;
      }
    }

    if (this.$currentOption == 2) {
      const percent_off_text = this.$variant_2_percent_off_texts[_this.$quantity - 1];
      if (percent_off_text != '') {
        this.$percentElement.innerText = percent_off_text;
      }
    }

    this.querySelector('[data-regular-price]').innerText = moneyFormat.replace('{{amount}}', (regular_price/100).toFixed(2));
    if (this.querySelector('[data-compare-price]')) {
      this.querySelector('[data-compare-price]').innerText = moneyFormat.replace('{{amount}}', (compare_at_price/100).toFixed(2));
    }
    if (this.querySelector('[data-save-price]')) {
      //this.querySelector('[data-save-price]').innerText = moneyFormat.replace('{{amount}}', (save_price*allQuantity/100));
    }
    this.querySelector('[data-save-price]').innerText = '20%';
  }
}

customElements.define('choose-form-box', ChooseFormBox);

class FeaturedReviewColumnTab extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const tabItems = this.querySelectorAll('.tab-header-item');
    tabItems.forEach((item) => {
      item.addEventListener('click', function(){
        tabItems.forEach((_item) => {
          _item.classList.remove('active');
        });
        item.classList.add('active');
        const tabID = item.dataset.tabId;
        _this.querySelectorAll('.featured-review-columns-tab-item').forEach((_item) => {
          _item.classList.remove('active');
        });
        _this.querySelector(`#tab-item-${tabID}`).classList.add('active');
      });
    });
  }
}
customElements.define('featured-review-column-tab', FeaturedReviewColumnTab);

class ProductPopupModal extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const popupOptions = this.querySelectorAll('[data-popup-option]');
    popupOptions.forEach((item) => {
      item.addEventListener('click', function(){
        popupOptions.forEach((_item) => {
          _item.classList.remove('active');
        });
        item.classList.add('active');
        const optionID = item.dataset.popupOption;
        _this.querySelectorAll('.popup-variant-option-image').forEach((_item) => {
          _item.classList.remove('active');
        });
        _this.querySelector(`.popup-variant-option-${optionID}-image`).classList.add('active');
      });
    });
  }

}
customElements.define('product-popup-modal', ProductPopupModal);